import(/* webpackMode: "eager" */ "/Users/ankitvirani/download_staging/69cfd1b334b9ae00142e8166_1784539102105_98aae2fb/signal_1775227314698/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/ankitvirani/download_staging/69cfd1b334b9ae00142e8166_1784539102105_98aae2fb/signal_1775227314698/src/styles/tailwind.css");
